import { render, staticRenderFns } from "./SearchResultContact.vue?vue&type=template&id=4a97fce5&scoped=true&"
import script from "./SearchResultContact.vue?vue&type=script&lang=js&"
export * from "./SearchResultContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97fce5",
  null
  
)

export default component.exports